<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div class="tabBarContent">
        <a-tabs 
            v-model:activeKey="activeKey" 
            type="editable-card" 
            :hideAdd="true"
            @edit="onEdit"
            @change="tabChange"
        >
            <a-tab-pane 
                v-for="pane in visitedViews" 
                :key="pane.name" 
                :tab="$t(pane.lang)" 
                :closable="pane.closable"
            ></a-tab-pane>
        </a-tabs>
    </div>
</template>

<script setup>
    import { ref, toRefs,toRaw,watch,onMounted, reactive } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import {storeToRefs} from 'pinia';
    import {useTagsView} from '@/store/tagsView';
    
    const route = useRoute()
    const router = useRouter()
    const tagsViewStore = useTagsView()
    let { visitedViews } = toRefs(tagsViewStore)
    let activeKey = ref('Home')
    let isAffixView = router.getRoutes().filter(i=>{
        return i.meta && i.meta.isAffix
    })

    // 初始化固定tab
    const initTags = ()=>{
        isAffixView.forEach(route=>{
            tagsViewStore.addViews({
                ...route.meta,
                name:route.name,
                path:route.path
            })
        })
    }

    // 添加tab
    const addTags = ()=>{
        // console.log(route,'路由变化了')
        const {name} = route
        name && tagsViewStore.addViews({
            ...route.meta,
            name:route.name,
            path:route.path
        })
        visitedViews.value = visitedViews.value.map(item=>{
            return {
                ...item,
                closable: !(item.name == 'Home')
            }
        })
        activeKey.value = route.name
    }

    // 删除tab
    const delTab = (name)=>{
        let tabItem = visitedViews.value.find(i=>i.name == name)
        router.push(`${tabItem.path}`)
    }

    // 点击tab
    function tabChange(activeKey){
        let tabItem = visitedViews.value.find(i=>i.name == activeKey)
        router.push(`${tabItem.path}`)
    }

    // 操作tab
    function onEdit(targetKey,action){
        if(action == 'remove'){
            remove(targetKey)
        }
    }
    // 关闭tab
    function remove(targetKey){
        let lastIndex = 0;
        visitedViews.value.forEach((item, i) => {
            if (item.name === targetKey) {
                lastIndex = i - 1
            }
        });
        visitedViews.value = visitedViews.value.filter(item => item.name !== targetKey)
        if (visitedViews.value.length && activeKey.value === targetKey) {
            if (lastIndex >= 0) {
                activeKey.value = visitedViews.value[lastIndex].name
            } else {
                activeKey.value = visitedViews.value[0].name
            }
        }
        let lastView = visitedViews.value.slice(-1)[0]
        delTab(lastView.name)
    }

    watch(
        ()=>route.path,
        ()=>addTags()
    )

    onMounted(() => {
        initTags()
        addTags()
    })

</script>

<style lang="scss" scoped>
.tabBarContent{
    // tab 默认状态
    ::v-deep .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab, 
    ::v-deep .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab{
        margin: 0 3px;
        padding: 4px 15px;
        border-radius: 3px;
    }

    // tab 激活态
    ::v-deep .ant-tabs-card > .ant-tabs-nav .ant-tabs-tab-active, 
    ::v-deep .ant-tabs-card > div > .ant-tabs-nav .ant-tabs-tab-active{
        border: 1px solid #1226aa;

        .ant-tabs-tab-remove .anticon{
            color: #1226aa;   
        }

    }

    ::v-deep .ant-tabs{
        margin: 10px 0;
    }

    ::v-deep .ant-tabs-top > .ant-tabs-nav::before, 
    ::v-deep .ant-tabs-bottom > .ant-tabs-nav::before, 
    ::v-deep .ant-tabs-top > div > .ant-tabs-nav::before, 
    ::v-deep .ant-tabs-bottom > div > .ant-tabs-nav::before{
        border-bottom: none;
    }

    ::v-deep .ant-tabs-top > .ant-tabs-nav, 
    ::v-deep .ant-tabs-bottom > .ant-tabs-nav, 
    ::v-deep .ant-tabs-top > div > .ant-tabs-nav, 
    ::v-deep .ant-tabs-bottom > div > .ant-tabs-nav{
        margin: 0;
    }

    ::v-deep .ant-tabs-tab-remove{
        padding: 0;
    }

    ::v-deep button:focus, 
    ::v-deep button:focus-visible{
        outline: none;
    }
}
</style>